const balanceReporterABI = require("./artifacts/balance_reporter_abi.json");
const accountManagerABI = require("./artifacts/account_manager_abi.json");
const safeBoxABI = require("./artifacts/safe_box_abi.json");
const transactionRouterABI = require("./artifacts/transaction_router_abi.json");
const savEthRegistryABI = require("./artifacts/saveth_registry_abi.json");
const savEthManagerABI = require("./artifacts/saveth_manager_abi.json");
const savETHBatchTxABI = require("./artifacts/saveth_batch_transaction_abi.json");
const slotSettlementRegistryABI = require("./artifacts/slot_settlement_registry_abi.json");
const erc20GenericABI = require("./artifacts/erc20_generic_abi.json");
const universeABI = require('./artifacts/universe_abi.json');
const savETHIndexNamingRegistryABI = require('./artifacts/saveth_index_naming_registry.json');

const stakehouseContracts = {
    BALANCE_REPORTER : balanceReporterABI,
    ACCOUNT_MANAGER : accountManagerABI,
    SAFE_BOX : safeBoxABI,
    TRANSACTION_ROUTER : transactionRouterABI,
    SAVETH_REGISTRY : savEthRegistryABI,
    SAVETH_MANAGER : savEthManagerABI,
    SAVETH_BATCH_TX : savETHBatchTxABI,
    SLOT_SETTLEMENT_REGISTRY : slotSettlementRegistryABI,
    ERC20_GENERIC : erc20GenericABI,
    UNIVERSE : universeABI,
    SAVETH_INDEX_NAMING_REGISTRY : savETHIndexNamingRegistryABI
};

module.exports = {
    stakehouseContracts
};
